import React from 'react'

import Container from '../../../components/structure/Container'
import CustomWorkspaceRedirect from './_redirect/CustomWorkspaceRedirect'
import DeactivatedPlaceMessage from './_redirect/DeactivatedPlaceMessage'
import InactiveQrcodeRedirect from './_redirect/InactiveQrcodeRedirect'
import QrcodeLoader from '../_load/QrcodeLoader'
import SimpleAuthPageTemplate from '../../../components/templates/SimpleAuthPageTemplate'
import ContentPage from './ContentPage'

const ShowQrcodePage = ({ id }) => {
  return (
    <SimpleAuthPageTemplate title={`QR Code: #${id}`}>
      <QrcodeLoader id={id}>
        <InactiveQrcodeRedirect>
          <DeactivatedPlaceMessage>
            <CustomWorkspaceRedirect>
              <Container>
                <ContentPage />
              </Container>
            </CustomWorkspaceRedirect>
          </DeactivatedPlaceMessage>
        </InactiveQrcodeRedirect>
      </QrcodeLoader>
    </SimpleAuthPageTemplate>
  )
}

export default ShowQrcodePage
